import React from 'react';
import { Sparkles, Shield } from 'lucide-react';
import { IMAGES } from '../data/mock';

const CreatorVision = ({ totalSessions = 6, totalFeedback = 1 }) => {
  return (
    <section id="creator" className="scroll-mt-24 py-12 sm:py-20">
      <div className="max-w-7xl mx-auto px-4">
        <div className="rounded-3xl border border-emerald-100 bg-white overflow-hidden shadow-sm">
          <div className="grid lg:grid-cols-2 items-center">
            <div className="p-8 sm:p-12">
              <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-emerald-700"><Sparkles className="w-3.5 h-3.5" /> Creator's Vision</span>
              <h2 className="mt-2 font-serif text-3xl sm:text-4xl md:text-5xl text-emerald-950">Built for Calm &amp; Clarity</h2>
              <p className="mt-4 text-emerald-900/80 leading-relaxed">
                Welcome to <strong>Win With Meditation</strong>. I created this platform as a peaceful, ad-free digital sanctuary for anyone seeking mental clarity, anxiety relief, or a quiet space to rest at the end of a long day.
              </p>
              <p className="mt-3 text-emerald-900/80 leading-relaxed">
                Whether you speak <strong>English</strong> or <strong>Hindi (हिंदी)</strong>, every audio track and guided meditation is crafted with care to help you reconnect with your inner strength.
              </p>

              <div className="mt-8 grid grid-cols-3 gap-4 border-t border-emerald-100 pt-6">
                <div>
                  <div className="font-serif text-3xl text-emerald-800">{totalSessions}</div>
                  <div className="text-xs uppercase tracking-widest text-emerald-700/80">Guided Sessions</div>
                </div>
                <div>
                  <div className="font-serif text-3xl text-emerald-800">{totalFeedback}</div>
                  <div className="text-xs uppercase tracking-widest text-emerald-700/80">Reflections &amp; Reviews</div>
                </div>
                <div>
                  <div className="font-serif text-3xl text-emerald-800">2</div>
                  <div className="text-xs uppercase tracking-widest text-emerald-700/80">Languages Supported</div>
                </div>
              </div>
            </div>
            <div className="relative aspect-[4/3] lg:aspect-auto lg:h-full">
              <img src={IMAGES.lake} alt="Meditation Sanctuary" className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
              <span className="absolute bottom-4 right-4 inline-flex items-center gap-1.5 rounded-full bg-white/90 backdrop-blur px-3 py-1.5 text-xs font-medium text-emerald-800">
                <Shield className="w-3.5 h-3.5" /> Ad-Free Peace Sanctuary
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreatorVision;
